module.exports = __webpack_public_path__ + "img/olc-screen-olc-1.272e7522.jpg";